import { useNuxtApp, useRouter } from '#app'
import { useLocalePath } from '#imports'
import { useGame } from '@/composables/game/useGame'
import { useSideMenu } from '@/composables/ui/useSideMenu'
import { useMainStore } from '@/stores/main'
import { useSideMenuStore } from '@/stores/sideMenu'
import { normalizeBasePath } from '@/utils/urlModal'

const GAME_PAGE_PATHS = ['/main/game', '/main/sportsbook', '/main/luckysport']

/**
 * 提款規則轉換後（結算、領 FREE_ 獎勵）回首頁並以新規則重載預設館別；遊戲中不打斷玩家。
 * @returns {{ resetToDefaultRoom: (options?: { originalModal?: string|null }) => Promise<void> }}
 */
export const useGameRoomDefault = () => {
  const nuxtApp = useNuxtApp()
  const mainStore = useMainStore()
  const sideStore = useSideMenuStore()

  // originalModal 為空時不代為關窗
  const resetToDefaultRoom = async ({ originalModal = null } = {}) => {
    // 在非元件生命週期內取得服務，避免關閉彈窗時停止首頁的輪詢；呼叫端也可能是 plugin 階段建立的 composable
    const { router, localePath, game, sideMenu } = nuxtApp.runWithContext(() => ({
      router: useRouter(),
      localePath: useLocalePath(),
      game: useGame(),
      sideMenu: useSideMenu(),
    }))
    const currentPath = normalizeBasePath(router.currentRoute.value.path)
    // 館別留待下次進首頁再載
    if (GAME_PAGE_PATHS.includes(currentPath)) return
    if (originalModal && mainStore.modal === originalModal) mainStore.setModal(null)

    if (currentPath !== '/main') {
      // 導頁被 guard 擋下或被後續導頁取代時，使用者已不在首頁，館別留待下次進首頁再載
      const failure = await router.push(localePath('/main'))
      if (failure) return
    }
    mainStore.setGameSearchPageEnable(false)
    sideStore.setHistoryStack([])
    sideStore.setPreviousMenuItemStack([])
    try {
      await sideMenu.getMenu()
    } finally {
      // 新規則下預設館別可能與原館 categoryId 相同，setRoom 會略過，需強制重載；選單刷新失敗時沿用舊的預設館別
      // 原館列表請求在途時 load() 會因 isLoadingMore 略過，導致新館別列表空白
      game.setIsLoadingMore(false)
      game.recoverSetRoom(sideStore.defaultMenuItemStack.at(-1))
    }
  }

  return { resetToDefaultRoom }
}
